import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledAddProfileIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 52 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 52,
			height: 52,
			rx: 12,
			fill: "#E6F7F1"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_4401_59689)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 26,
					cy: 26,
					r: 15.75,
					fill: "#33BF8D",
					stroke: "#147752",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.25 24.5C31.25 27.3995 28.8995 29.75 26 29.75C23.1005 29.75 20.75 27.3995 20.75 24.5C20.75 21.6005 23.1005 19.25 26 19.25C28.8995 19.25 31.25 21.6005 31.25 24.5Z",
					fill: "white",
					stroke: "#147752",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "path-4-inside-1_4401_59689",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M13.6797 36.9747C15.791 32.2738 20.5136 29 26.0009 29C31.4881 29 36.2107 32.2738 38.322 36.9747C35.3001 40.365 30.8998 42.5 26.0009 42.5C21.1019 42.5 16.7016 40.365 13.6797 36.9747Z"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M13.6797 36.9747C15.791 32.2738 20.5136 29 26.0009 29C31.4881 29 36.2107 32.2738 38.322 36.9747C35.3001 40.365 30.8998 42.5 26.0009 42.5C21.1019 42.5 16.7016 40.365 13.6797 36.9747Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.6797 36.9747L12.3114 36.3601L11.913 37.247L12.5599 37.9728L13.6797 36.9747ZM38.322 36.9747L39.4418 37.9728L40.0887 37.247L39.6904 36.3601L38.322 36.9747ZM15.048 37.5893C16.9262 33.4074 21.1256 30.5 26.0009 30.5V27.5C19.9016 27.5 14.6558 31.1402 12.3114 36.3601L15.048 37.5893ZM26.0009 30.5C30.8761 30.5 35.0755 33.4074 36.9537 37.5893L39.6904 36.3601C37.3459 31.1402 32.1001 27.5 26.0009 27.5V30.5ZM37.2023 35.9766C34.4529 39.0611 30.4543 41 26.0009 41V44C31.3453 44 36.1473 41.6689 39.4418 37.9728L37.2023 35.9766ZM26.0009 41C21.5474 41 17.5488 39.0611 14.7994 35.9766L12.5599 37.9728C15.8545 41.6689 20.6564 44 26.0009 44V41Z",
					fill: "#147752",
					mask: "url(#path-4-inside-1_4401_59689)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 36.5,
					cy: 36.5,
					r: 6.75,
					fill: "white",
					stroke: "#147752",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.5 36.5H39.5",
					stroke: "#147752",
					strokeWidth: 1.5,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.5 33.5V39.5",
					stroke: "#147752",
					strokeWidth: 1.5,
					strokeLinecap: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4401_59689",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 36,
				height: 36,
				fill: "white",
				transform: "translate(8 8)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFilledAddProfileIcon);
const Memo = memo(ForwardRef);
export default Memo;
